import { NgModule } from '@angular/core';
import { ApolloClientOptions, ApolloLink, GraphQLRequest, InMemoryCache } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { environment } from 'src/environments/environment';
import { SettingsService } from './settings.service';
import { UmbracoTokenService } from './umbraco-token.service';

const createApollo = (
  httpLink: HttpLink,
  umbracoTokenService: UmbracoTokenService,
  settingsService: SettingsService
): ApolloClientOptions<any> => {
  const basic = setContext(async (operation: GraphQLRequest) => {
    let apiKey: string | null = null;
    if (operation.operationName?.startsWith('Preview')) {
      apiKey = (await umbracoTokenService.getPreviewToken()).key;
    }

    const umbracoProjectAlias = !environment.umbraco.projectAlias
      ? (await settingsService.getUmbracoSettings()).projectAlias
      : environment.umbraco.projectAlias;

    return {
      headers: {
        ['accept']: 'charset=utf-8',
        ['umb-project-alias']: umbracoProjectAlias,
        ['Accept-Language']: 'nl-NL',
        ...(apiKey && {
          ['Api-Key']: apiKey
        })
      }
    };
  });

  const link = ApolloLink.from([basic, httpLink.create({ uri: environment.umbraco.graphQLServerUrl })]);

  return {
    link,
    cache: new InMemoryCache()
  };
};

@NgModule({
  imports: [ApolloModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink, UmbracoTokenService, SettingsService]
    }
  ]
})
export class GraphQLModule {}
